import config from '@/config';
import Pusher from 'pusher-js';

export class PusherService {
  private _pusher: Pusher;

  constructor(driver: string, key: string) {
    let options = {};
    options =
      driver == 'soketi'
        ? {
            wsHost: config.pusherAHost,
            wssPort: 4210,
            forceTLS: true,
            disableStats: true,
          }
        : {
            cluster: config.pusherCluster,
            // authEndpoint: config.apiURL + '/pusher/auth',
            forceTLS: false,
          };
    this._pusher = new Pusher(key, options);
    this._pusher.connection.bind('connected', () => console.log('[socket] Mevrik connected to ' + driver));
    this._pusher.connection.bind('error', () => console.log('[socket] Websoket connection error ' + driver));
  }

  subscribe(channel: string) {
    this._pusher.subscribe(channel);
  }

  unsubscribe(channel: string) {
    this._pusher.unsubscribe(channel);
  }

  on(event: string, callback: (data: unknown) => void) {
    this._pusher.bind(event, callback);

    return () => {
      this._pusher.unbind(event, callback);
    };
  }
}
